<template>
    <nav class="hidden sm:block w-full bg-white p-4 dark:bg-grey-900 shadow-md rounded-lg" aria-label="Breadcrumb" v-if="!isTotem">
        <ol class="inline-flex items-center space-x-1 md:space-x-3">
            <li class="inline-flex items-center" v-for="(item, index) in navigation" :key="item.name">
                <div class="flex items-center">
                    <svg v-if="index > 0" class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                            clip-rule="evenodd" />
                    </svg>
                    <Link :href="item.href"
                        class="ml-1 text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2 dark:text-gray-400 dark:hover:text-white">
                    {{ item.name }}</Link>
                </div>
            </li>
        </ol>
    </nav>
</template>
<script>
import { Link, usePage } from '@inertiajs/vue3';
export default {
    props: ['navigation'],
    components: {
        Link
    },
    computed: {
        isTotem() {
            const page = usePage();
            return page.props.auth.user.roles.filter((role) => role.name === 'totem').length > 0;
        }
    }
};
</script>